import { observer } from 'mobx-react-lite'

import { AlignmentTypeMap } from '@showrunner/codex'

import { Toolbar } from '#components/Toolbar'
import { useMst } from '#state'
import { capitalize, setAlignment } from '#util'

export const AlignmentButtons = observer(function AlignmentButtons() {
  const { currentScript } = useMst()
  const observableEditor = currentScript?.observableEditor
  if (!observableEditor) {
    return null
  }

  const { editorView, disableAlignment, selectionAlignment } = observableEditor

  return (
    <>
      {[
        AlignmentTypeMap.ALIGN_LEFT,
        AlignmentTypeMap.ALIGN_CENTER,
        AlignmentTypeMap.ALIGN_RIGHT,
      ].map((opt) => (
        <Toolbar.Button
          key={opt}
          icon={`fa-align-${opt}`}
          tooltip={capitalize(opt) + ' align'}
          onClick={() => {
            setAlignment(opt)(observableEditor.editorState, editorView.dispatch)
            currentScript.trackEvent('PARAGRAPH_ALIGNMENT_CHANGED')
          }}
          disabled={disableAlignment || !!currentScript.readOnlyByPlan}
          active={selectionAlignment === opt}
          focusEditor
        />
      ))}
    </>
  )
})
